/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {configureAdminResourceStates} from '../common/controller/admin-resource-routing';
import {SiteResource} from '../../components/api/resources/resource/site.resource';
import {SiteGroupResource} from '../../components/api/resources/resource/site-group.resource';



export function siteGroupStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterAndChildHelper('site-groups.site-group', SiteGroupResource, SiteResource, 'app.inv', 'app');
    
        // Same pattern as blocklist / external-ad-unit: edit + analysis are mounted
        // directly in UI-Router views so modelComms reaches them.
        configureAdminResourceStates($stateProvider, rh, {
          objectType: 'SiteGroup',
          editTag: 'adn-site-group-edit-page',
          twoPanel: {
            rightTag: 'adn-site-group-analysis-page'
          },
          listTag: 'adn-site-group-list-page',
          listResolve: {
            readOnly: /*@ngInject*/ function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasNetwork('MANAGE_SYSTEM');
            }
          }
        });
  }, adnRouterHelper);
}
